import { BaseModal } from './base_modal.component';
import { WarningIcon } from 'components/icons/warning_icon.component';

interface ErrorModalProps {
  title: string;
  isOpen: boolean;
  hasCross?: boolean;
  children?: JSX.Element;
  onClose: () => void;
}

export function ErrorModal( { title, isOpen, children, onClose, hasCross = true }: ErrorModalProps ) {

  /*------------------------------- Front -------------------------------*/
  return (
    <BaseModal
      title={ title }
      isOpen={ isOpen }
      onClose={ onClose }
      icon={ <WarningIcon className='w-10 p-2'/> }
      iconColor='#f87171'
      hasCross={ hasCross }
    >
      { children }
    </BaseModal>
  );
}